const getDefaultState = () => {
  return {
    uuid: null,
    knowConsumption: 1,
    knowNetConsumption: 1,
    consumptions: {
      electricity: {
        mono: null,
        day: null,
        night: null,
        exclusiveNight: null,
        injectionBase: null,
        injectionDay: null,
        injectionNight: null,
      },
      gas: null
    },
    smartMeter: {
      hasSmartMeter: false,
      hasQuarterRegime: false,
      knowPeakLevel: false,
      peakLevel: null,
    },
    inhabitants: 1,
    houseSize: 3,
    occupation: 'evening_weekend',
    heating: 'gas',
    water: 'gas',
    dishwasher: false,
    dryer: false,
    washingMachine: false,
    electricCar: false,
    battery: false
  }
}

export default {
  getDefaultState
}



// WEBPACK FOOTER //
// ./src/store/modules/consumption/default.js